import { isLocalUrl } from '../helpers/helpers';

export default function videoText() {
  const widgetName = 'videoText';
  const widgetOpts = videoTextOpts;
  const $widget = $(`#${widgetName}`);
  const wrapContainerClass = 'videoText-container';

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    moreButton: {
      visible: true,
      text: 'More',
    },
    buyNowButton: {
      visible: true,
      text: 'Buy Now',
    },
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    showDescription: true,
    link: [''],
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        videoTextLayout();
        videoTextButtons();
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function videoTextLayout() {
    const $wrapper = $('<div class="card-widget-text-wrapper"></div>');
    $widget.find('.card-widget-title, .card-widget-description').wrapAll($wrapper);
  }

  function videoTextButtons() {
    const $buttons = $widget.find('.buttonwrap a');

    if ($buttons.length > 0) {
      $buttons.parent().append($buttons.get().reverse());

      $buttons.addClass('button');
      $buttons.each(function () {
        const $btn = $(this);
        const url = $btn.attr('href');

        if (isLocalUrl(url)) {
          $btn.removeAttr('target');
        }
      });
    }
  }
}
